import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  LEAVE_TYPE_LIST_REQUEST,
  LEAVE_TYPE_LIST_SUCCESS,
  LEAVE_TYPE_LIST_FAILURE,
  LEAVE_TYPE_LIST_RESET,
  LEAVE_TYPE_CREATE_REQUEST,
  LEAVE_TYPE_CREATE_SUCCESS,
  LEAVE_TYPE_CREATE_FAILURE,
  LEAVE_TYPE_CREATE_RESET,
  LEAVE_TYPE_GET_REQUEST,
  LEAVE_TYPE_GET_SUCCESS,
  LEAVE_TYPE_GET_FAILURE,
  LEAVE_TYPE_GET_RESET,
  LEAVE_TYPE_EDIT_REQUEST,
  LEAVE_TYPE_EDIT_SUCCESS,
  LEAVE_TYPE_EDIT_FAILURE,
  LEAVE_TYPE_EDIT_RESET,
  LEAVE_TYPE_DELETE_REQUEST,
  LEAVE_TYPE_DELETE_SUCCESS,
  LEAVE_TYPE_DELETE_FAILURE,
  LEAVE_TYPE_DELETE_RESET,
  LEAVE_TYPE_EXPORT_REQUEST,
  LEAVE_TYPE_EXPORT_SUCCESS,
  LEAVE_TYPE_EXPORT_FAILURE,
  LEAVE_TYPE_EXPORT_RESET,
} from './../../constants'

export function createLeaveType(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-types`,
      method: 'POST',
      types: [
        LEAVE_TYPE_CREATE_REQUEST,
        LEAVE_TYPE_CREATE_SUCCESS,
        LEAVE_TYPE_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function getLeaveType(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-types`,
      method: 'GET',
      types: [
        LEAVE_TYPE_LIST_REQUEST,
        LEAVE_TYPE_LIST_SUCCESS,
        LEAVE_TYPE_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function getLeaveTypeByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-types/${id}`,
      method: 'GET',
      types: [
        LEAVE_TYPE_GET_REQUEST,
        LEAVE_TYPE_GET_SUCCESS,
        LEAVE_TYPE_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function editLeaveType(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-types/${id}`,
      method: 'PUT',
      types: [
        LEAVE_TYPE_EDIT_REQUEST,
        LEAVE_TYPE_EDIT_SUCCESS,
        LEAVE_TYPE_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function deleteLeaveType(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-types/${id}/delete`,
      method: 'PUT',
      types: [
        LEAVE_TYPE_DELETE_REQUEST,
        LEAVE_TYPE_DELETE_SUCCESS,
        LEAVE_TYPE_DELETE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportLeaveType(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-types/exports`,
      method: 'GET',
      types: [
        LEAVE_TYPE_EXPORT_REQUEST,
        LEAVE_TYPE_EXPORT_SUCCESS,
        LEAVE_TYPE_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetGetLeaveType() {
  return {
    type: LEAVE_TYPE_LIST_RESET,
  }
}
export function resetGetLeaveTypeByID() {
  return {
    type: LEAVE_TYPE_GET_RESET,
  }
}
export function resetCreateLeaveType() {
  return {
    type: LEAVE_TYPE_CREATE_RESET,
  }
}
export function resetEditLeaveType() {
  return {
    type: LEAVE_TYPE_EDIT_RESET,
  }
}
export function resetDeleteLeaveType() {
  return {
    type: LEAVE_TYPE_DELETE_RESET,
  }
}
export function resetExportLeaveType() {
  return {
    type: LEAVE_TYPE_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/leave-type/leave-type-action.js